import styled from 'styled-components';
import { lighten } from 'polished';

export const ContainerLegalRepresentative = styled.div`
  margin: 50px 0;
  font-family: Poppins;
  font-style: normal;

  & > h2 {
    margin: 0.764vw 0;
    font-weight: 600;
    font-size: 1.389vw;
  }

  & > div {
    min-width: 300px;
    border-radius: 10px;
    padding-bottom: 10px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 10px;
    grid-row-gap: 10px;

    & h4 {
      margin: 20px 0 0 20px;
      font-size: 18px;
    }

    & .card {
      /* background-color: ${lighten('0.1', '#DCDCDC')}; */
      border-radius: 0.8rem;
    }
  }

  .box-legal-representative-data {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 45px;
    border-bottom: 1px solid gray;
  }

  .box-legal-representative-data-last {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 45px;
    .MuiRadio-colorSecondary.Mui-checked {
      color: #ff557e !important;
    }
  }

  .MuiFormControlLabel-label {
    font-size: 16px;
    padding: 10px;
    font-weight: bold;
  }

  .box-legal-representative-data > p {
    font-size: 1.111vw;
  }

  .box-legal-representative-title-data {
    text-transform: uppercase;
    font-weight: bolder;
  }

  .box-legal-representative-actions {
    width: 60%;
    display: flex;
    justify-content: space-between;
    margin: 30px 20px 10px;
  }
`;
